import axios from 'axios'
import { Toast } from 'vant';


// let loadingInstance = null    Loading, // 加载全局的loading

const instance = axios.create({    //创建axios实例，在这里可以设置请求的默认配置
  timeout: 10000, // 设置超时时间10s
  // baseURL: 'http://wx.xinbafar.com.cn/'
  baseURL: ''
})
// 文档中的统一设置post请求头。下面会说到post请求的几种'Content-Type'
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

let httpCode = {
  400: '请求参数错误',
  401: '权限不足, 请重新登录',
  403: '服务器拒绝本次访问',
  404: '请求资源未找到',
  500: '内部服务器错误',
  501: '服务器不支持该请求中使用的方法',
  502: '网关错误',
  504: '网关超时'
}

/** 添加请求拦截器 **/
instance.interceptors.request.use(config => {
  // loadingInstance = Loading.service({       // 发起请求时加载全局loading，请求失败或有响应时会关闭
  //   spinner: 'fa fa-spinner fa-spin fa-3x fa-fw',
  //   text: '拼命加载中...'
  // })
  if(config.showLoad) {
    Toast.loading({
      message: "加载中...",
      forbidClick: true,
      duration: 0
    });
  }
  if (config.method === 'get') { // 添加时间戳参数，防止浏览器（IE）对get请求的缓存
    config.params = {
      ...config.params,
      t: new Date().getTime()
    }
  }
  return config
}, error => {
  // 对请求错误做些什么
  return Promise.reject(error)
})

/** 添加响应拦截器  **/
instance.interceptors.response.use(response => {
  let config = response.config;
  if(config.showLoad) {
    Toast.clear();
  }
  console.log(response);
  if (response.data.code === '10000') {
    return Promise.resolve(response.data)
  } else {
    Toast(response.data.message)
    return Promise.reject(response.data.message)
  }
}, error => {
  if (error.response) {
    // 根据请求失败的http状态码去给用户相应的提示
    let tips = error.response.status in httpCode ? httpCode[error.response.status] : error.response.data.message
    Toast(tips)
    return Promise.reject(error)
  } else {
    Toast('请求超时, 请刷新重试')
    return Promise.reject(new Error('请求超时, 请刷新重试'))
  }
})

export default instance